<template>
  <div class="listBox">
    <div class="report-item" v-if="item && type == '1'">
      <div @click="goDetails(item)" class="mark" v-if="isSearch"></div>
      <AuthorInfo
        :isFocus="focus"
        :user="item.user ? item.user : {}"
        :time="item.create_time"
      />
      <div class="content" @click="goDetails(item)">
        <p
          :class="['c_title', longTxt ? '' : 'van-multi-ellipsis--l3']"
          v-html="checkSearch(item.content, item.tag)"
        >
          <!-- <span v-if="item.tag" @click.stop="jumpPage(item.tag.id)">{{'#'+item.tag.title+'#'}}</span>{{item.content}} -->
        </p>
        <div v-if="item.attach">
          <!-- 图片 -->
          <template
            v-if="item.attach.length > 0 && item.attach[0].type === '0'"
          >
            <div class="img-box" ref="imgBox">
              <van-image
                lazy-load
                fit="cover"
                :width="item.attach.length > 1 ? '32.8%' : 268"
                :height="item.attach.length > 1 ? 110 : 151"
                v-for="(elem, index) in item.attach"
                :key="elem.id"
                :src="elem.url"
                @click.stop="imgView(index, item.id)"
              />
            </div>
          </template>
          <!-- 视频 -->
          <template
            v-if="item.attach.length > 0 && item.attach[0].type === '1'"
          >
            <div v-if="isSearch" class="video_thumb">
              <van-image
                lazy-load
                fit="cover"
                width="100%"
                :height="153"
                :src="item.attach[0].poster"
              />
              <i class="playBtn"></i>
            </div>
            <TcVideo
              v-if="!isSearch"
              :id="item.id"
              :poster="item.attach[0].poster"
              :url="item.attach[0].url ? item.attach[0].url : ''"
            />
          </template>
          <!-- 音频 -->
          <template
            v-if="item.attach.length > 0 && item.attach[0].type === '2'"
          >
            <AudioPlayer :url="item.attach[0].url ? item.attach[0].url : ''" />
          </template>
        </div>
        <div v-if="isPL" class="options flex align-center justify-end">
          <span @click.stop="jumpDown" class="msg">{{ item.comment }}</span>
          <span @click.stop="jumpDown" class="like">{{ item.likes }}</span>
        </div>
      </div>
    </div>
    <div
      :style="{ 'border-bottom': border ? '1px solid #eee' : '' }"
      class="report-item bgf8"
      v-if="type == '2'"
    >
      <div v-for="(elem, index) in item" :key="index">
        <AuthorInfo
          :isFocus="focus"
          :user="elem.user"
          :time="elem.create_time"
        />
        <div class="content" @click="goDetails(elem)">
          <p class="c_title van-multi-ellipsis--l3">
            <span @click.stop="jumpPage(elem.tag.id)">{{
              elem.tag ? "#" + elem.tag.title + "#" : ""
            }}</span
            >{{ elem.content }}
          </p>
          <!-- 图片 -->
          <template
            v-if="elem.attach.length > 0 && elem.attach[0].type === '0'"
          >
            <div class="img-box" ref="imgBox2">
              <van-image
                lazy-load
                fit="cover"
                :width="elem.attach.length > 1 ? '32.8%' : 268"
                :height="elem.attach.length > 1 ? 110 : 151"
                v-for="(obj, index) in elem.attach"
                :key="obj.id"
                :src="obj.url"
                @click.stop="imgView2(index, elem.id)"
              />
            </div>
          </template>
          <!-- 视频 -->
          <template
            v-if="elem.attach.length > 0 && elem.attach[0].type === '1'"
          >
            <TcVideo
              :id="elem.id"
              :poster="elem.attach[0].poster"
              :url="elem.attach[0].url ? elem.attach[0].url : ''"
            />
          </template>
          <!-- 音频 -->
          <template
            v-if="elem.attach.length > 0 && elem.attach[0].type === '2'"
          >
            <AudioPlayer :url="elem.attach[0].url ? elem.attach[0].url : ''" />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AuthorInfo, TcVideo, AudioPlayer } from "@/components";
import Contents from "@/request/base.default.js";
import { store } from "@/store";
// import { navigate, checkWx } from '@/pages/index/custom'

export default {
  components: {
    AuthorInfo,
    TcVideo,
    AudioPlayer,
  },
  props: {
    item: {
      type: [Object, Array],
      default: null,
    },
    isClick: {
      type: [Boolean],
      default: true,
    },
    type: {
      type: [String],
      default: "1",
    },
    focus: {
      type: [Boolean],
      default: true,
    },
    border: {
      type: [Boolean],
      default: false,
    },
    isSearch: {
      type: [Boolean],
      default: false,
    },
    longTxt: {
      type: [Boolean],
      default: false,
    },
    isPL: {
      type: [Boolean],
      default: true,
    },
  },
  data() {
    return {
      imgs: [], // 图片预览数组
    };
  },
  methods: {
    // 打开图片预览
    imgView(index, id) {
      let { imgBox } = this.$refs;
      let imgs = [];
      for (const item of imgBox.children) {
        imgs.push(item.children[0].src);
      }
      let params = {
        index,
        id,
        imgs,
      };
      this.$emit("openImgBox", params);
    },
    imgView2(index, id) {
      let { imgBox2 } = this.$refs;
      let imgs = [];
      for (const item of imgBox2[0].children) {
        imgs.push(item.children[0].src);
      }
      let params = {
        index,
        id,
        imgs,
      };
      this.$emit("openImgBox", params);
    },
    // 转到详情页
    goDetails(item) {
      if (this.$props.isClick) {
        this.$router.push({ path: "details", query: { id: item.id } });
      }
    },
    // 话题列表跳转
    jumpPage(id = "") {
      if (this.$props.isClick) {
        this.$router.push({ path: "topicDetails", query: { id: id } });
      }
    },
    jumpDown() {
      window.location.href = Contents.downURL;
      // if(checkWx()) {
      //     navigate('', Contents.downURL + '?mini=1')
      // } else {
      //     navigate('', Contents.downURL)
      // }
    },
    checkSearch(val, tag) {
      let word = store.state.searchWord;
      let str = val.replace(
        eval("/" + word + "/g"),
        `<span style="color: red">${word}</span>`
      );
      let str2 = "";
      if (tag) {
        str2 = `<span style="color: #2E8CFF; margin-right: 4px">#${tag.title}#</span>`;
      }
      return str2 + str;
      // if(val.indexOf(word) != -1) {
      //     console.log(val.indexOf(word))
      // }
      // if(tag) {
      //     return '#' + val + '#'
      // } else {
      //     console.log(val)
      // }
    },
  },
};
</script>

<style lang="less" scoped>
.video_thumb {
  width: 268px;
  height: 153px;
  border-radius: 6px;
  overflow: hidden;
  position: relative;
  .playBtn {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -1.75rem;
    margin-top: -1.75rem;
    width: 3.5rem;
    height: 3.5rem;
    background: url(../assets/img/ic_playBtn.png) no-repeat;
    background-size: 100% 100%;
  }
}
.mark {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 200;
}
.listBox {
  background-color: #f8f8f8;
}
.report-item {
  height: 100%;
  padding: 1.25rem;
  background-color: #fff;
  position: relative;
  .content {
    margin-top: 0.5rem;
    .c_title {
      font-size: 16px;
      font-weight: 400;
      color: #222222;
      margin-bottom: 0.5rem;
      span {
        color: #2e8cff;
        margin-right: 0.25rem;
      }
    }
    .options {
      margin-top: 1.125rem;
      span {
        padding-left: 1.5rem;
        font-size: 12px;
        font-weight: 400;
        color: #222;
      }
      .msg {
        background: url("../assets/img/line@2x.png") no-repeat center left;
        background-size: 1.25rem 1.25rem;
        margin-right: 2.125rem;
      }
      .like {
        background: url("../assets/img/toolbar.png") no-repeat center left;
        background-size: 1.25rem 1.25rem;
      }
    }
  }
}
.img-box::after {
  content: "";
  display: block;
  clear: both;
}
.van-image {
  border-radius: 0.375rem;
  overflow: hidden;
  margin-bottom: 0.125rem;
  float: left;
}
.van-image:not(:nth-child(3n)) {
  margin-right: 0.8%;
}
.van-image::nth-child(3n-1) {
  border-radius: 0 !important;
}
.van-image-preview {
  & > div:nth-child(2) {
    bottom: 18px !important;
  }
}
.bgf8 {
  background-color: #fff;
}
</style>